import React from 'react';
import { Row, Col } from 'antd';
import Book from '../book';
// import PropTypes from 'prop-types';

export default class NewListRec extends React.Component {
    render() {
        const content = this.props.data.reduce((res, item, idx) => {
            if (idx % this.props.column) {
                res[parseInt(idx / this.props.column, 10)].push(item);
            } else {
                res.push([item]);
            }
            return res;
        }, []).map((arr, idx) => (
            <Col key={idx}>
                {arr.map((item, idx2) => (
                    <Book key={idx2} template={this.props.template} {...item} />
                ))}
            </Col>
        ));
        return (
            <div style={this.props.sty}>
                {this.props.header && <h3 style={{ fontSize: '26px', color: '#333', lineHeight: '84px', margin: '0px' }}>{this.props.header}</h3>}
                <Row type="flex" justify="space-between">
                    {content}
                </Row>
            </div>
        );
    }
}






// WEBPACK FOOTER //
// ./src/component/rec/new_list_rec.js